import QuestionViewVerbal from "./QuestionViewVerbal";

export default class QuestionViewBoolean extends QuestionViewVerbal {
    constructor(question) {
        super(question);
    }

    getHeaderText(){
        if (this._question.type === "vertices"){
            const data = P3.assets.json("templates");
            const split = this._question.template.split("/");
            let templates = data.templates[split[0]][split[1]];

            if (templates && templates.length > 0)
                templates = templates.slice().filter(x => this.filterTemplate(x));

            if (!templates || !templates.length)
                return "ERROR: NO TEMPLATE FOUND";

            this._template = P3.utils.selectRandom(templates);

            let text = this._template ? this._template.text : "";
            if (this._template) {
                let match = text.match(/\[VALUE([0-9])?]/g);
                if (match){
                    for (let i = 0; i < match.length; i++) {
                        text = text.replace(match[i], this._question.shape);
                    }
                }
            }
            return text;
        }
        else {
            return super.getHeaderText();
        }
    }

    filterTemplate(x) {
        return x.correct ? x.correct == this._question.answer.value : true;
    }

    isCorrect() {
        return parseInt(this._inputValue.value) === parseInt(this._question.answer.value);
    }
}